import { defineMessages } from 'react-intl';

export const scope = 'app.components.InfoBox';

export default defineMessages({
  archived: {
    id: `${scope}.archived`,
    defaultMessage: 'Archived',
  },
});
